(function(angular) {
	'use strict';
    var isNotNumber = function(value) {
        return value === undefined || value === null || value === '' || isNaN(parseFloat(value));
    };

	var core = angular.module('Core');

	core.directive('stlDatePicker', function($timeout, $log, Language) {
		return {
			restrict: 'E',
			require: ['ngModel', '?^stlForm'],
			replace: true,
			transclude: false,
			scope: {
				model: '=ngModel',
				startDate: '=startDate',
				endDate: '=endDate',
				required: '=required',
                dayMonthOnly: '=dayMonthOnly'
			},
			template: function (e, a) {
				var tmpl = '';
				var ro = '';

				if (a['readonly']) {
					ro = ' readonly="true"';
				}

				tmpl += '<span class="datepicker-core">';

				if (a['required']) {
					tmpl += '	<div class="date" ng-class="getNgClassRequired()">';
				} else {
					tmpl += '	<div class="date">';
				}

				tmpl += '		<div class="input-group input-group-sm">';
				tmpl += '			<input type="text" class="form-control input-sm datepicker-core-data" ng-class="getNgClassRequired()" '+ro+' />';
				tmpl += '			<input type="text" class="form-control input-sm datepicker-core-dp" readonly value="" ng-class="getNgClassRequired()" />';
				tmpl += '			<span class="input-group-btn">';
				tmpl += '				<button class="btn btn-default" type="button" ng-click="showDP()" tabindex="-1">';
				tmpl += '					<span class="glyphicon glyphicon-calendar" aria-hidden="true"></span>';
				tmpl += '				</button>';
				tmpl += '			</span>';
				tmpl += '		</div>';
				tmpl += '	</div>';
				tmpl += '</span>';

				return tmpl;
			},
			link: function (scope, element, attrs, reqs) {
				var dpFormat = 'dd.mm.yyyy'; // View format
				var viewFormat = 'DD.MM.YYYY'; // View format
                var viewFormatFull = 'DD.MM.YYYY'; // View format
				var viewFormatSmall = 'DD.MM.YY'; // View format (with only 2 years digit...)
				var modelFormat = 'YYYY-MM-DD'; // JSON model format
                var dayMonthFormat = 'DD.MM';

                var yearPreset = null;

                var setYearPreset = function(year) {
                    yearPreset = year;
                    viewFormat = dayMonthFormat;
                };

                if (scope.dayMonthOnly) {
                    setYearPreset(scope.dayMonthOnly);
                }

                scope.$watch('dayMonthOnly', function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setYearPreset(newVal);
                    }
                });

				var inputHidden = element.find('input.datepicker-core-dp');
				var input = element.find('input.datepicker-core-data');

				var stlForm = reqs[1];
				var controller = reqs[0];

				scope.getNgClassRequired = function () {
					if (!scope.model) {
						return 'input-error : true';
					} else {
						return '';
					}
				};

				var setDpFieldVisible = function(visible) {
					if (visible) {
						inputHidden.css('display', 'block');
						input.css('display', 'none');
					} else {
						inputHidden.css('display', 'none');
						input.css('display', 'block');
					}
				};
				setDpFieldVisible(false);

				var dpTarget = inputHidden;
				var formatModelDate = function(date) {
					if (date === undefined) {
						return null;
					}
					var formatted = moment(date).format(modelFormat);
                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }
					return formatted;
				};
				var parseModelDate = function(dateString) {
					var date = null;
					if (dateString !== undefined && dateString !== '') {
						date = moment(dateString, modelFormat).toDate();
					}
					if (date && isNaN(date.getTime())) {
						date = null;
					}
                    if (date === 'Invalid date') {
                        date = null;
                    }
					return date;
				};

				var formatDate = function(date) {
					if (date === undefined) {
						return null;
					}
                    var formatted = null;
                    if (yearPreset) {
                        formatted = moment(date).format(viewFormatFull);
                    } else {
                        formatted = moment(date).format(viewFormat);
                    }

                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }

					return formatted;
				};

                var formatViewDate = function(date) {
                    if (date === undefined) {
                        return null;
                    }
                    var formatted = moment(date).format(viewFormat);
                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }
                    return formatted;
                };

				var parseDate = function(dateString) {
					var date = null;
					if (dateString !== undefined && dateString !== '') {
                        if (yearPreset) {
                            date = moment(dateString + '.' + yearPreset, viewFormatFull).toDate();
                        } else {
                            date = moment(dateString, viewFormat).toDate();
                            if (date.getFullYear() < 1000) {
                                date = moment(dateString, viewFormatSmall).toDate();
                            }
                        }
					}

                    if (date === 'Invalid date') {
                        date = null;
                    }

					if (date !== undefined && date !== null && isNaN(date.getTime())) {
						date = null;
					}
					return date;
				};
				// Define locale to use
				var locale = Language.current();
				if (locale !== undefined) {
					locale = locale.toLowerCase();
				} else {
					locale = 'fr';
				}

				var createPicker = function() {
					var config = {
						format: dpFormat,
						autoclose: true,
						todayBtn: true,
						todayHighlight: true,
						orientation: 'auto',
						keyboardNavigation: true,
						language: locale
					};

					if (scope.startDate) {
						config.startDate = parseModelDate(scope.startDate);
					}
					if (scope.endDate) {
						config.endDate = parseModelDate(scope.endDate);
					}

					var dp = dpTarget.datepicker(config);
					dp.on('hide', function() {
						setDpFieldVisible(false);
					});
					dp.on('changeDate', function() {
						update();
					});
					return dp;
				};

				var picker = null;
				/*
				 *
				 * @returns {DatePicker} create or get the date picker
				 */
				var getPicker = function() {
					if (picker === null) {
						picker = createPicker();
					}
					return picker;
				};

				var pickerSet = function() {
					return picker !== null;
				};

				var updatePicker = function() {
					if (pickerSet()) {
						dpTarget.datepicker('update');
					}
				};

				var update = function() {
					getPicker();
					var dpDate = dpTarget.datepicker('getDate');
					if (dpDate) {
						$timeout(function() {
							var date = dpDate;
							var time = null;
							if (date !== null) {
								time = date.getTime();
							}

							if (time !== null && isNaN(time)) {
								time = null;
							} else {
								time = formatModelDate(time);
							}

							if (scope.model !== time) {
								scope.model = time;
								controller.$setViewValue(scope.model);
							}
						});
					} else {
						$timeout(function() {
							if (scope.model !== null) {
								scope.model = null;
								controller.$setViewValue(scope.model);
							}
						});
					}
				};

				var updateUserValue = function(withEnter) {
					$timeout(function() {
						var val = input.val();
						var date = null;
						var viewVal = '';
						var modelVal = null;
						if (val) {
							date = parseDate(val);
							viewVal = formatViewDate(date);
							modelVal = formatModelDate(date);
							// Update the datepicker
							if (pickerSet()) {
                                if (yearPreset) {
                                    dpTarget.val(formatDate(date));
                                } else {
                                    dpTarget.val(viewVal);
                                }
								dpTarget.datepicker('update');
							}
						}
						if (scope.model !== modelVal) {
							scope.model = modelVal;
							controller.$setViewValue(scope.model);
							input.val(viewVal);
						}

						if (withEnter === true && stlForm) {
							// let's call the default action
							stlForm.submit();
						}
					});
				};

				var cls = $(element).attr('class');
				input.attr('class', input.attr('class') + ' ' + cls);
				var fill = function(data) {
					if (data !== undefined && data !== null) {
						var date = parseModelDate(data);
						if (Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())) {
							input.val(formatViewDate(date));
							inputHidden.val(formatDate(date));
							updatePicker();
						}
						else {
							input.val(null);
							inputHidden.val(null);
							updatePicker();
						}
					} else {
						input.val(null);
						inputHidden.val(null);
						updatePicker();
					}
				};
				fill(scope.model);

				scope.$watch('model', function(dt) {
					fill(dt);
				});

				scope.$watch('startDate', function(newSD, oldSD) {
					if (newSD !== oldSD /*|| div.datepicker('getDate').getTime() < parseModelDate(newSD).getTime()*/) {
						if (scope.model !== undefined && newSD !== undefined && scope.model < newSD) {
							scope.model = null;
						}
						if (pickerSet()) {
							if (newSD) {
								dpTarget.datepicker('setStartDate', parseModelDate(newSD));
							} else {
								dpTarget.datepicker('setStartDate', null);
							}
						}
					}
				});
				scope.$watch('endDate', function(newSD, oldSD) {
					if (newSD !== oldSD) {
						if (scope.model !== undefined && newSD !== undefined && scope.model > newSD) {
							scope.model = null;
						}
						if (pickerSet()) {
							if (newSD) {
								dpTarget.datepicker('setEndDate', parseModelDate(newSD));
							} else {
								dpTarget.datepicker('setEndDate', null);
							}
						}
					}
				});
				scope.clearDP = function() {
					scope.model = null;
					controller.$setViewValue(null);

					getPicker();
					dpTarget.datepicker('update', new Date());
				};
				scope.showDP = function() {
					setDpFieldVisible(true);
					dpTarget.focus();

					getPicker();
					dpTarget.datepicker('show');
				};

				// Event binding
				input.bind({
					blur: updateUserValue
				});
				input.keypress(function(event) {
					if (event.which === 13) {
						event.preventDefault();
						updateUserValue(true);
					}
				});
			}
		};
	});
    core.directive('stlSmartFloat', ['$timeout', function($timeout) {
			/**
			 * Parameters:
			 * ng-model: binding
			 * min-value: minimal value
			 * max-value: maximal value
			 * precision: number after comma (optional, default 2)
			 */
			return {
				restrict: 'E',
				require: 'ngModel',
				scope: {
					model: '=ngModel',
					minValue: '=',
					maxValue: '=',
					precision: '=',
					change: '&ngChange'
				},
				replace: true,
				template: '<input type="text"></input>',
				link: function(scope, element, attrs, controller) {
					var precision = 2;
					scope.$watch('precision', function(p) {
						if (scope.precision !== null) {
							precision = scope.precision;
						} else {
							precision = 2;
						}
					});

					var formatValue = function(value) {
						if (value === null || value === '') {
							return '';
						} else {
							return accounting.formatNumber(value, {
								thousand: '\'',
								decimal: '.',
								precision: precision
							});
						}
					};

					var setValue = function(value) {
						$timeout(function() {
							var val = parseFloat(value);
							if (isNaN(val)) {
								val = null;
							}

							scope.model = val;

							controller.$setViewValue(val);
							controller.$setValidity('number', true);

							if (val !== null) {
								var viewValue = formatValue(val);
								$(element).val(formatValue(viewValue));
							} else {
								$(element).val(scope.model);
							}



							if (scope.change !== undefined) {
								scope.change();
							}
						});
					};
					var fix = function() {

						if ($(element).val() === null || $(element).val() === '') {
							return '';
						}

						var value = accounting.formatNumber($(element).val(), {
							thousand: '',
							decimal: '.',
							precision: precision
						});
						return value;
					};

					var showWarn = function(warn) {
						if (warn) {
							$(element).css('border-color', '#AD6D00');
							$(element).css('color', '#AD6D00');
						} else {
							$(element).css('border-color', 'inherited');
							$(element).css('color', 'inherited');
						}
					};

					var validate = function() {
						var vv = fix();
						var warnClass = false;
						if (scope.minValue !== null && scope.minValue !== '' && vv !== null && vv < scope.minValue) {
							vv = scope.minValue;
							warnClass = true;
						}
						if (scope.maxValue !== null && scope.maxValue !== '' && vv !== null && vv > scope.maxValue) {
							vv = scope.maxValue;
							warnClass = true;
						}

						showWarn(warnClass);
						setValue(vv);
					};
					scope.$watch('minValue', function(newValue, oldValue) {
						if (newValue !== oldValue) {
							validate();
						}
					});
					scope.$watch('maxValue', function(newValue, oldValue) {
						if (newValue !== oldValue) {
							validate();
						}
					});
					scope.$watch('model', function(newValue) {
						var viewValue = formatValue(newValue);
						$timeout(function() {
							$(element).val(viewValue);
						}, 100);
					});
					element.bind('focus', function() {
						$(element).val(scope.model);
					});
					element.bind('blur', function() {
						validate();
					});
					// Unbing ng-model on change
					element.unbind('input').unbind('keydown').unbind('change');
				}
			};
		}]);
	core.directive('stlSuggestBox', ['$timeout', '$q', function($timeout, $q) {
		return {
				require: 'ngModel',
				restrict: 'E',
				scope: {
					model: '=ngModel',
					editable: '@',
					asyncFunction: '&',
					itemFormatter: '&',
					required: '=?ngRequired'
				},
				template: '<span class="stlSuggestBox"><input type="text"' +
						'ng-required="required" ' +
						'ng-model="model"' +
						'typeahead="item.value as item.label for item in getItems($viewValue)"' +
						'typeahead-editable="editable"' +
						'typeahead-input-formatter="inputFormatter()"' +
						'typeahead-wait-ms="200"></span>',
				link: function(scope, element, attribute, ngModel) {
					scope.inputFormatter = function(item) {
						if (scope.itemFormatter) {
							return scope.itemFormatter({
								item: scope.model
							});
						}
						return item;
					};
					scope.getItems = function(val) {
						var deferred = $q.defer();
						scope.asyncFunction({
							viewValue: val
						}).then(function(data) {
							var items = [];
							for (var i = 0; i < data.data.length; i++) {
								var item = data.data[i];
								var label = item;
								if (scope.itemFormatter) {
									label = scope.itemFormatter({item: label});
								}
								items.push({
									label: label,
									value: item
								});
							}
							deferred.resolve(items);
						});

						return deferred.promise;
					};
				}
			};
		}]);



	/*
	 * multi-options: {
	 *		getKey: function(item) { return the key attached to this object }
	 *		getLabel: function(item) { return the text associated to this object}
	 *		idAsValue: boolean (true to use the id instead of the full object in the multi select)
	 *		tags : boolean (true to use tag adding)
	 * }
	 */
	core.directive('stlMultiSelect', function($timeout, $log) {
		return {
			require: ['ngModel', '^?stlForm'],
			restrict: 'E',
			scope: {
				model: '=ngModel',
				multiData: '=',
				multiOptions: '=?',
				onChange: '&?'
			},
			compile: function(elem, attributes) {
				var isMulti = '';
				if (attributes.multiple !== undefined) {
					isMulti = 'multiple';
				}

				elem.append('<div class="stl-multi-select"><input type="hidden" ' + isMulti + ' ></div>');


				var link = function(scope, element, attrs, controller) {
					scope.multiple = isMulti;

					var options = {};
					if (scope.multiOptions) {
						options = scope.multiOptions;
					}
					scope.$watch('multiOptions', function(newVal) {
						if (newVal) {
							options = newVal;
						}
					}, true);

					var input = $(element.find('input'));
					var select2 = null;
					var dataLoaded = false;
					var initialized = false;

					var loadedData = {};

					var getKey = function(item) {
						if (options.getKey) {
							return options.getKey(item);
						} else {
							return item.id;
						}
					};

					var getLabel = function(item) {
						if (options.getLabel) {
							return options.getLabel(item);
						} else if (item.text) {
							return item.text;
						} else {
							return getKey(item);
						}
					};

					var getNewModelFromTag = function(tag) {
						if (options.getNewModelFromTag) {
							return options.getNewModelFromTag(tag);
						} else {
							return {
								id: tag,
								text: tag
							};
						}
					};

					var updateModel = function(data) {
						// Here we get the ids...
						// Let's get the data attached to this id !
						var results = [];

						if (data && data.length > 0) {
							var res = [];
							for (var i = 0; i < data.length; i++) {
								var id = data[i];

								if (options.idAsValue === true) {
									res.push(id);
								} else {
									var loaded = loadedData[id];
									if (loaded && loaded.data) {
										res.push(loaded.data);
									} else if (scope.multiOptions && scope.multiOptions.tags) {
										res.push(getNewModelFromTag(id));
									} else {
										// data not found...
										$log.warn('stlMultiSelect: No data found for key ' + id);
									}
								}
							}
							if (res.length > 0) {
								results = res;
							} else if (!scope.model) {
								// Keep the same value than model...
								results = scope.model;
							} else {
								results = [];
							}
						}

						$timeout(function() {
							if (initialized && !angular.equals(scope.model, results)) {
								scope.model = results;
								if (controller[1].isEditing()) {
									controller[0].$setViewValue(results);
								}
							}
						});
					};

					var initSelection = function(elt, callback) {
						var val = $(elt).val();
						var ids = [];
						if (val) {
							ids = val.split(',');
						}

						var full = [];

						for (var i = 0; i < ids.length; i++) {
							var id = ids[i];
							// Let's get data...
							var text = '';
							var data = loadedData[id];
							if (!data || !data.text) {
								text = id;
							} else {
								text = data.text;
							}
							var d = {
								id: id,
								text: text
							};
							full.push(d);
						}

						callback(full);
					};

					var doGetSelection = function(data) {
						var ret = null;
						var val = data;
						if (val) {
							ret = val.split(',');
						}
						return ret;
					};

					var getSelection = function() {
						return doGetSelection(getSelect().val());
					};

					var createSelect = function() {
						var s2 = input.select2({
							allowClear: true,
							data: scope.multiData,
							multiple: scope.multiple,
							initSelection: initSelection,
							query: getData
						});
						s2.on('change', function() {
							updateModel(getSelection());
							if (scope.onChange) {
								scope.onChange();
							}
						});

						select2 = s2;

						return select2;
					};

					var getSelect = function() {
						if (select2 === null) {
							createSelect();
						}
						return select2;
					};

					var updateSelection = function(data) {
						if (!dataLoaded) {
							getData();
						} else {

							// Create a list of keys...
							var values = [];

							if (data) {
								for (var i = 0; i < data.length; i++) {
									var d = data[i];
									var key;
									if (options.idAsValue === true) {
										key = d;
									} else {
										key = getKey(d);
									}
									values.push(key);
								}
							}

							getSelect().val(values);

							if (dataLoaded) {
								getSelect().trigger('change');
							}
						}
					};

					var customIds = 0;
					var getData = function(query) {
						var matchs = [];
						var items = [];

						var fullMatch = false;
						if (scope.multiData) {
							for (var im = 0; im < scope.multiData.length; im++) {
								var d = scope.multiData[im];

								var result = {
									id: getKey(d),
									text: getLabel(d)
								};

								if (query && query.matcher) {
									if (query.matcher(query.term, result.text, {})) {
										if (result.text === query.term) {
											fullMatch = true;
										}
										matchs.push(result);
										items.push(d);
									}
								} else {
									matchs.push(result);
									items.push(d);
								}
							}
							if (query && query.term && query.term.length > 0 && scope.multiOptions && scope.multiOptions.tags && !fullMatch) {
								matchs.unshift({id: query.term, text: query.term});
							}
						}

						var data = {
							results: matchs
						};

						for (var i = 0; i < items.length; i++) {
							var item = items[i];
							var key = getKey(item);
							loadedData[key] = {};

							var text = getLabel(item);

							loadedData[key].text = text;
							loadedData[key].data = item;
						}

						if (query) {
							query.callback(data);
						}

						if (!dataLoaded) {
							dataLoaded = true;
							if (scope.model) {
								updateSelection(scope.model);
							}
						}
					};

					/*
					 * Update the loaded data and set the model data object...
					 */
					var updateLoadedData = function(model) {
						if (model) {
							for (var i = 0; i < model.length; i++) {
								var d = model[i];
								var key = getKey(d);
								if (!loadedData[key]) {
									loadedData[key] = {};
								}
									loadedData[key].text = getLabel(d);
									loadedData[key].data = d;

							}
						}
					};

					scope.$watchCollection('model', function(newVal, oldVal) {
						if (!angular.equals(newVal, oldVal)) {
							initialized = true;
							updateLoadedData(newVal);
							updateSelection(newVal);
						}
					});

					scope.$watchCollection('multiData', function(newVal, oldVal) {
						if (newVal && newVal.length > 0) {
							initialized = true;
							updateSelection(scope.model);

						}
					});

					if (scope.model) {
						updateSelection(scope.model);
					} else {
						createSelect();
					}
				};
				return link;
			}

		};
	});

	core.directive('select', function($parse) {
		return {
			restrict: 'E',
			compile: function(element, attributes) {
				element.append('<option value="">&nbsp;</option>');
				return function(scope, elt, attrs) {
					scope.$watch(attrs['ngModel'], function(data) {
						var model = $parse(attrs['ngModel']);  // Get the model
						if (data !== '' || typeof data === 'boolean') {
							if (typeof data === 'boolean') {
								model.assign(scope, data + '');  // Assigns a value to it
							}
						} else {
							model.assign(scope, null);  // Assigns a value to it
						}
						//scope.$apply();
					}, true);

				};
			}
		};
	});
	core.directive('regexValidator', ['StringUtil', function(StringUtil) {
		var regexMasks = {
			regexEmail: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}',
			regexPhone: '([\\+][0-9]{11})?|([0][0-9]{9})?',
			regexFloat: '[0-9]+[.]?[0-9]*'
		};
		return {
			restrict: 'A',
			require: ['^stlForm', 'ngModel'],
			scope : {
				regexValidator: '@'
			},
			link: function(scope, element, attr, ctrl) {
				var mask;
				var stlForm = ctrl[0];
					var form;
					var regex = regexMasks[scope.regexValidator] ? regexMasks[scope.regexValidator] : scope.regexValidator;
				if (stlForm) {
					form = stlForm.getForm();
				}

					mask = new RegExp(regex, 'g');
				function customValidator(ngModelValue) {
					//console.log(mask.exec(ngModelValue));
						/*console.log(ngModelValue.match(mask));
					if (mask.test(ngModelValue)) {
						ctrl[1].$setValidity('uppercaseValidator', true);
					} else {
						ctrl[1].$setValidity('uppercaseValidator', false);
					}*/
						if (StringUtil.regexGlobalMatch(ngModelValue, regex)) {
							ctrl[1].$setValidity('uppercaseValidator', true);
						} else {
							ctrl[1].$setValidity('uppercaseValidator', false);
						}
					return ngModelValue;
				}

				ctrl[1].$parsers.push(customValidator);


			}
		};
		}]);
	core.directive('stlMask', function() {
		var regexMasks = {
			regexEmail: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}',
			regexPhone: '([\\+][0-9]{11})?|([0][0-9]{9})?',
			regexFloat: '[0-9]+[.]?[0-9]*'
		};

		return {
			restrict: 'A',
			require: ['^stlForm', 'ngModel'],
			link: function(scope, element, attribute, tab) {
				var noError = attribute['stlMaskNoError'] !== undefined;

				var stlForm = tab[0];
				//var ngModel = tab[1];
				var mask = attribute['stlMask'];

				var editing = false;
				var originalValue = null;

				var form = null;
				if (stlForm) {
					form = stlForm.getForm();
				}

				var validElement = function() {
					var value = $(element).val();
					if (editing === false) {
						return;
					}

					scope.$apply(function() {
						tab[1].$setViewValue(value);
					});

					if ($(element).inputmask('isComplete') || value === undefined || value === '') {
						$(element).removeClass('input-error');
						scope.$apply(function() {
							if (form) {
								form.$setValidity('mask', true);
							}
						});
					} else if (!noError) {
						$(element).addClass('input-error');
						scope.$apply(function() {
							if (form) {
								form.$setValidity('mask', false);
							}
						});
					}
				};

				var options = {
					onKeyValidation: function() {
						validElement();
					},
					onKeyUp: validElement
				};

				if (regexMasks[mask] !== undefined) {
					options['regex'] = regexMasks[mask];
					mask = 'Regex';
				} else if (attribute['customRegex']) {
					options['regex'] = attribute['customRegex'];
					mask = 'Regex';
				}

				$(element).inputmask(mask, options);// .on('keydown', validElement);
				//$(element).inputmask('Regex', {regex: "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"});
				//$(element).inputmask('email');
				//$(element).inputmask('Regex', {regex: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}'});
				//$(element).inputmask('Regex', {regex: '[\\+]?[0-9-]+'});


				$(element).bind('focus', function() {
					editing = true;
					originalValue = $(element).val();
				});
				$(element).bind('blur', function() {
					editing = false;
					originalValue = null;
				});
			}
		};
	});

	/*
	 * Apply a regex to the field and check
	 *
	 * Attributes:
	 *	stl-regex: Your regex to use
	 *	stl-regex-policy:
	 *		-warning: show a warning (default)
	 *		-validation: Change validation status
	 *	stl-regex-i18n-key: the message to show when the field is invalid
	 *	stl-regex-text: The message to show in the popup (override stl-regex-i18n-key)
	 */
	core.directive('stlRegex', function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				model: '=ngModel'
			},
			link: function(scope, element, attribute, controller) {
				var input = $(element);

				var regex = attribute['stlRegex'];
				//var policy = 'validation';

				var getValue = function() {
					if (input && input.val) {
						return input.val();
					}
					return null;
				};

				var isValid = function() {
					var value = getValue();
					var vcheck = '';
					if (!value) {
						return true; // We allow blank...
					}

					vcheck = value;

					var rex = new RegExp('^' + regex + '$', 'gi');
					var res = rex.test(vcheck);
					return res;
				};

				var validate = function() {
					var valid = isValid();
					if (valid) {
						$(element).removeClass('input-warn');
					} else {
						$(element).addClass('input-warn');
					}
				};

				input.bind({
					blur: validate
				});

				scope.$watch('model', function() {
					validate();
				});
			}
		};
	});

	/**
	 * This select is auto disabled when the list is empty or when only 1 entry is present
	 * When only 1 entry is present, this entry is auto selected
	 */
	core.directive('stlCriteriaSelect', ['$timeout', function($timeout) {
			return {
				require: 'ngModel',
				restrict: 'E',
				scope: {
					model: '=ngModel',
					options: '@',
					listData: '=',
					listChange: '&',
					listAutoSelect: '&',
					noEmpty: '@',
					emptyName: '=?'
				},
				template:
						'<select stl-select ng-model="model" ng-options="{{options}}" ng-change="handleChange()" ng-disabled="disabled">' +
						'<option ng-style="displayEmpty" value="">{{emptyName}}</option>' +
						'</select>',
				link: function(scope) {
					scope.displayEmpty = '';
					if (!scope.emptyName) {
						scope.emptyName = '';
					}


					if (scope.noEmpty && scope.noEmpty === 'true') {
						scope.displayEmpty = {display: 'none'};
					}
					var autoSelect = function() {
						var list = [];
						if (scope.listData) {
							list = scope.listData;
						}

						scope.disabled = list.length <= 1;

						if (list.length === 1 && scope.model !== list[0]) {
							// auto select...
							scope.model = list[0];
							scope.handleChange();
						}
					};

					scope.handleChange = function() {
						if (scope.listChange) {
							$timeout(function() {
								scope.listChange();
							}, 20);
						}
					};

					scope.$watchCollection('listData', function() {
						autoSelect();
						scope.$data = scope.listData;
					});

					autoSelect();
				}
			};
		}]);

    core.directive('stlCurrencyInput', function ($filter) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {

                var isFocused = false;
                var selectContent = true;

                var myBlurFunctionToCall = attrs.resetIfEmpty;

                var nbDecimals = attrs['stlCurrencyInput'];
                if (!nbDecimals) {
                    nbDecimals = 2;
                }

                var isDot = function(e) {
                    return e.which === 46;
                };

                var isNumber = function(e) {
                    return e.which >= 48 && e.which <= 57;
                };

                var arrondi5Centime = function(value) {
                    if (!value) {
                        return 0;
                    }
                    if (nbDecimals < 0) {
                        return value;
                    }
                    var n = parseFloat(value);
                    return Math.round(n * 20) / 20;
                };

                var isBlank = function(value) {
                    return (value === undefined || value === null || value === '');
                };

                var isNotBlank = function(value) {
                    return !isBlank(value);
                };

                var isFieldRequired = function() {
                    return angular.isDefined(attrs.required);
                };

                elm.bind('blur', function () {
                    isFocused = false;

                    if (ctrl.$viewValue) {
                        ctrl.$modelValue = arrondi5Centime(ctrl.$modelValue);
                        ctrl.$viewValue = $filter('currency')(ctrl.$modelValue, nbDecimals, 0);
                    } else if (myBlurFunctionToCall) {
                        scope.$eval(myBlurFunctionToCall);
                    }
                    ctrl.$render();
                });

                elm.bind('focus', function () {
                    isFocused = true;
                    if (!isFieldRequired() && isNaN(ctrl.$modelValue)) {
                        ctrl.$modelValue = 0;
                    }
                    if (isNotBlank(ctrl.$modelValue)) {
                        ctrl.$modelValue = arrondi5Centime(ctrl.$modelValue);
                    }

                    if (angular.isDefined(attrs.required) && isBlank(ctrl.$modelValue)) {
                        ctrl.$viewValue = '';
                    } else {
                        ctrl.$viewValue = '' + ctrl.$modelValue.toFixed(2);
                    }

                    ctrl.$render();
                    if (selectContent) {
                        this.select();
                    }
                    selectContent = true;
                });

                elm.bind('mousedown', function() {
                    selectContent = false;
                });

                elm.bind('keypress', function (e) {
                    var value = ctrl.$modelValue ? ctrl.$modelValue.toString() : '';
                    if (!(isDot(e) || isNumber(e))) {
                        e.preventDefault();
                        return;
                    }
                    if (isDot(e) && value && value.indexOf('.') > -1) {
                        e.preventDefault();
                        return;
                    }
                });

                ctrl.$formatters.push(function () {
                    var defaultValue = 0;
                    if (isFieldRequired()) {
                        defaultValue = '';
                    }
                    if (ctrl.$modelValue !== 0) {
                        ctrl.$modelValue = ctrl.$modelValue || defaultValue;
                    }
                    if (isFocused) {
                        if (nbDecimals >= 0) {
                            return arrondi5Centime(ctrl.$modelValue).toFixed(2);
                        } else {
                            return ctrl.$modelValue > 0 ? ctrl.$modelValue : '';
                        }
                    }
                    return $filter('currency')(ctrl.$modelValue, nbDecimals, 0);
                });
            }
        };
    });
	core.directive('stlPercentageInput', function ($filter) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, ele, attr, ctrl) {

				function getNombreDecimals() {
					var decimals = attr.decimals ? parseInt(attr.decimals) : 2;
					return decimals;
				}

                ctrl.$parsers.unshift(function (viewValue) {
					if (viewValue === null || angular.isUndefined(viewValue) || viewValue === '') {
						return undefined;
					}
					var val = parseFloat(viewValue) / 100;
					if(!isNaN(val)) {
					    return val;
                    } else {
					    return undefined;
                    }
				});

                ctrl.$formatters.unshift(function (modelValue) {
					if (angular.isDefined(modelValue)) {
						return $filter('percentage')(modelValue, getNombreDecimals());
					}
				});

                ctrl.$validators.min = function (modelValue, viewValue) {
                    if(!angular.isDefined(modelValue)) {
                        return true;
                    }

                    if(angular.isDefined(attr['min']) && modelValue < attr['min'] / 100) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };

                ctrl.$validators.max = function (modelValue, viewValue) {
                    if(!angular.isDefined(modelValue)) {
                        return true;
                    }

                    if(angular.isDefined(attr['max'])  && modelValue > attr['max'] / 100) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };

				ele.on('blur', function () {
					if (angular.isDefined(ctrl.$modelValue)) {
						ele.val($filter('percentage')(ctrl.$modelValue, getNombreDecimals()));
					}
					else if (angular.isDefined(ctrl.$viewValue) && !isNotNumber(ctrl.$viewValue)) {
					    ele.val($filter('percentage')(ctrl.$viewValue / 100, getNombreDecimals()));
                    }
				});

				ele.bind('focus', function () {
					if (ctrl.$modelValue !== undefined && ctrl.$modelValue !== null) {
                        var viewValue = $filter('percentage')(ctrl.$modelValue, getNombreDecimals(), false);
                        ctrl.$viewValue = viewValue.replace(new RegExp('\'', 'g'), '');
					}
                    ctrl.$render();
				});
			}
		};
	});

	core.directive('stlNumber', function () {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {
				function parseNumbers(text) {
					var transformedInput = text.replace(/[^0-9]/g, '');
					if (transformedInput !== text) {
						ctrl.$setViewValue(transformedInput);
						ctrl.$render();
					}
					return transformedInput;
				}
				ctrl.$parsers.push(parseNumbers);
			}
		};
	});


    core.directive('testDirective', function() {
        return {
            restrict: 'E',
            scope: {
                dayMonthOnly: '=dayMonthOnly'
            },
            link: function (scope, element, attrs, reqs) {



                var setLabel = function(text) {
                    console.log(text);
                };

                setLabel(scope.dayMonthOnly);

                /*
                scope.$watch('dayMonthOnly', function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setLabel(newVal);
                    }
                });
                */
                attrs.$observe('dayMonthOnly', function() {

                });

            }
        };
    });

})(angular);
